import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const beGetSettingsNcob = actionBe('beGetSettingsNcob', ({ AT, ATAG }) =>
  endpoint(H.get, 'settings/ncob/salon/:salonId/', { AT, name: ATAG }),
);

// noinspection JSUnusedGlobalSymbols
export default beGetSettingsNcob;
